/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";

import { TiggbeeHeader } from './tiggbee-header';
import { TiggbeeFooter } from './tiggbee-footer';
import "./layout.css";

const Layout = ({ children, hideFooter = false }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);
  console.log(data);

  return (
    <>
      <div id='LayoutContainer' className='layout-container'>
        <TiggbeeHeader />
        <div>
          <main>{children}</main>
        </div>
        {!hideFooter && <TiggbeeFooter />}
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
